import React from "react";

const funFacts = [
  {
    count: "1200",
    suffix: "",
    text: "Vehicle Fleet",
    bg: "/images/resources/funfact-bg-1-1.jpg",
  },
  {
    count: "50",
    suffix: "k+",
    text: "Kilometer of Drive",
    bg: "/images/resources/funfact-bg-1-2.jpg",
  },
  {
    count: "400",
    suffix: "+",
    text: "Pickup & Drop",
    bg: "/images/resources/funfact-bg-1-3.jpg",
  },
  {
    count: "20",
    suffix: "K+",
    text: "Booking Reserved",
    bg: "/images/resources/funfact-bg-1-4.jpg",
  },
];

const FunFact = () => {
  return (
    <section className="funfact-one section-space">
      <div
        className="funfact-one__bg"
        style={{
          backgroundImage:
            "url(/images/backgrounds/funfact-bg-1-1.jpg)",
        }}
      ></div>

      <div className="container">
        <div className="row">
          {funFacts.map((item, index) => (
            <div className="col-xl-3 col-lg-4" key={index}>
              <div className="funfact-one__item count-box">
                <div
                  className="funfact-one__item__bg"
                  style={{
                    backgroundImage: `url(${item.bg})`,
                  }}
                ></div>

                <h3 className="funfact-one__funfact__count">
                  <span
                    className="count-text"
                    data-stop={item.count}
                    data-speed="1500"
                  >
                    {item.count}
                  </span>
                  {item.suffix && <span>{item.suffix}</span>}
                </h3>

                <p className="funfact-one__funfact__text">{item.text}</p>

                <div className="funfact-one__border__group">
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FunFact;